{
  document.querySelectorAll('.rose-judge-form').forEach(form => {
    const select = form.querySelector('select')
    const textarea = form.querySelector('textarea')
    const maybeSetRequired = (e) => {
      if(select.value == 'finalist'){
        textarea.setAttribute('required', true)
      } else {
        textarea.removeAttribute('required')
      }
    }

    select.addEventListener('change', e => maybeSetRequired())
    maybeSetRequired()
  })
}